import { select, put } from "redux-saga/effects";
import {
  tokenSelector,
  impersonatedPartner,
} from "../../ui/sites/oncall/selectors/auth";
import { logout } from "../../ui/sites/oncall/actions/auth";

export const oncallFetch = function*(url, body) {
  const token = yield select(tokenSelector);
  const partner = yield select(impersonatedPartner);
  const actualUrl = partner ? `${url}?_switch_user=${partner.id}` : url;
  const response = yield fetch(actualUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (response.ok) {
    const json = yield response.json();
    if (json.error) {
      throw new Error(json.error.message);
    }
    return json;
  }
  //noinspection MagicNumberJS
  if (response.status === 403 || response.status === 401) {
    yield put(logout());
  }
  if (response.status === 500) {
    throw new Error("Something went wrong");
  }
  throw new Error(response.status + ": " + response.statusText);
};



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/fetch-helper.js